import React from "react";
import { Button, Form } from "antd";
import { Form as FinalForm, Field } from "react-final-form";
import api from "services/api";
import FormGroup from "components/form/formGroup";

export default function NoteModal({
  contactId,
  premiumPurchaseId,
  premiumPurchaseNote,
  onChange,
  onClose,
}) {
  const successHandler = ({ data }) => {
    onChange(data);
    onClose();
  };

  const onSubmit = (formData) => {
    api
      .updatePremiumPurchase(contactId, premiumPurchaseId, formData)
      .then(successHandler);
  };

  const initialValues = {
    note: premiumPurchaseNote,
  };

  return (
    <FinalForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, submitting }) => (
        <Form layout="vertical" style={{ minWidth: "150px" }}>
          <Field
            style={{ width: "100%" }}
            name="note"
            type="textarea"
            minRows={4}
            component={FormGroup}
          />
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={submitting}
            style={{ position: "relative", top: "-20px" }}
          >
            {submitting ? "Please wait..." : "Save"}
          </Button>
        </Form>
      )}
    />
  );
}
